import { type Ref } from "vue";

import { injectStrict } from "../utils";
import {
  formDataKey,
  resetValidationErrorsKey,
  validationErrorsKey,
} from "./form";

export function useForm<T>() {
  const validationErrors = injectStrict(validationErrorsKey);
  const formData = injectStrict<Ref<T>>(formDataKey);
  const resetValidationErrors = injectStrict(resetValidationErrorsKey);

  if (!formData) {
    throw new Error("useForm must be used inside a FormProvider");
  }

  return {
    validationErrors,
    resetValidationErrors,
    formData,
  };
}
